import { AppInfoContextProviderProps } from '@kc/app-init-workflow/react';
import React, { PropsWithChildren } from 'react';

export type AppInfoContextMockProviderProps<T> = PropsWithChildren<AppInfoContextProviderProps<T>>;

export const AppInfoContextProviderMock = <T,>({ children }: AppInfoContextMockProviderProps<T>) => {
  return <>{children}</>;
};
